module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_5010.69101160.png";